module.exports = __webpack_public_path__ + "img/more3.4230a6f6.png";